import React, { useState } from "react";
import "./basketballclicnicblock.css"; // if you have styling
import { Link } from "react-router-dom";
import EnquiryModal from "../../EnquiryModal/EnquiryModal";

const BasketBallClicnicBlock = ({
  image,
  name,
  description,
  benifitsText,
  benifits,
  order,
  buttonText,
  buttonLink,
  setShowModal,
}) => {
  // const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className={`basketballclicnicblock-ss-block-ui ${order}`}>
        {/* Image */}
        <div className="ssb-img">
          {/* <img src={image} alt={name} /> */}
          <img src={image} title={name} />
        </div>

        {/* Content */}
        <div className="ssb-cnt">
          <div className="ssb-title">
            <h2 className="text-clip">{name}</h2>
          </div>

          <div className="ssb-desc">
            <p className="text-clip" style={{ marginBottom: "20px" }}>
              {description}
            </p>
          </div>

          <div className="ssb-title">
            {benifits.length > 0 && (
              <span className="text-clip">{benifitsText}</span>
            )}
          </div>

          <div className="ssb-desc">
            <ul>
              {benifits.map((i) => (
                <li className="text-clip">{i}</li>
              ))}
            </ul>
          </div>

          <div className="ssb-desc">
            {buttonText === "Inquiry now" ? (
              <a
                onClick={() => setShowModal(true)}
                className="vb-btn"
                style={{ cursor: "pointer" }}
              >
                <span className="text-clip">{buttonText}</span>
              </a>
            ) : (
              <Link to={buttonLink} className="vb-btn">
                <span className="text-clip">{buttonText}</span>
              </Link>
            )}
          </div>
        </div>
      </div>
      {/* {showModal && <EnquiryModal onClose={() => setShowModal(false)} />} */}
    </>
  );
};

export default BasketBallClicnicBlock;
